interface Finish {
  name: string;
  cost_modifier?: number;
}

export const finishNameWithModifier = (finish: Finish): String =>
  finish.cost_modifier
    ? `${finish.name} (+${(finish.cost_modifier * 100 - 100).toFixed(0)}% to cost)`
    : finish.name;
